import React from 'react';
import PropTypes from 'prop-types';
import lstrings from '../../../../../utils/LStrings';
import { Panel } from 'react-bootstrap';
import ScrollableAnchor from 'react-scrollable-anchor'
import PermissionChecker from '../../../../../components/permission-checker/PermissionChecker';
import TableDeudoresCentro from '../../../../../components/panel-situacion-financiera/components/TableDeudoresCentro';
import 'react-bootstrap-table/css/react-bootstrap-table.css';

class PanelNodoFederal extends React.Component {

    onRequestInfo = (infoKey, infoTitle) => {
        this.props.onRequestInfo(lstrings.situacionFinanciera_title, infoTitle);
    }

    render() {
        let titulo = <h2><i className="fa fa-usd"></i>  {lstrings.denuncias_nodoFederal}</h2>;

        return (
            <ScrollableAnchor id={'panel-situacionfinanciera'}>
                <Panel collapsible defaultExpanded header={titulo}>
                    <PermissionChecker
                        infoKey='deudoresCentroComercial'
                        infoTitle={process.env.REACT_APP_FLAVOR === "reseller" ? lstrings.denuncias_nodoFederal : lstrings.verazObsTitle}
                        data={this.props.deudoresCentro}
                        onRequestInfo={this.onRequestInfo}
                        hidePanels={this.props.hidePanels}
                    >
                        {
                            this.props.deudoresCentro &&
                            <TableDeudoresCentro
                                data={this.props.deudoresCentro}
                                onRequestInfo={this.onRequestInfo}
                                hidePanels={this.props.hidePanels}
                            />
                        }
                    </PermissionChecker>
                </Panel>
            </ScrollableAnchor>
        )
    }

}

PanelNodoFederal.propTypes = {
    deudoresCentro: PropTypes.any,
    onRequestInfo: PropTypes.func,
    hidePanels: PropTypes.any
};

export default PanelNodoFederal;


// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/PanelNodoFederal.js